/** Career payout scaling keeps late armory prices achievable without inflating onboarding. */
export const CAREER_SALVAGE_SCALE_START_RANK = 10;
export const CAREER_SALVAGE_SCALE_PER_RANK = 0.035;

/**
 * World salvage stays unchanged through Rank 10, then rises smoothly with the
 * career. Rank 50 pays 2.4× and Rank 100 pays 4.15× before sortie/heat bonuses.
 */
export function careerSalvageMultiplier(pilotRank: number): number {
  const rank = Math.min(100, Math.max(1, Math.floor(pilotRank)));
  return 1 + Math.max(0, rank - CAREER_SALVAGE_SCALE_START_RANK) * CAREER_SALVAGE_SCALE_PER_RANK;
}

export function scaleCareerSalvage(amount: number, pilotRank: number): number {
  if (amount <= 0) return 0;
  return Math.max(1, Math.round(amount * careerSalvageMultiplier(pilotRank)));
}
